import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  TableRow,
  TableCell,
  Button,
  Typography,
  Grid,
  Checkbox as MuiCheckbox,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Formik } from 'formik';
import * as moment from 'moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Input, Select, Checkbox } from '../Shared/BsInput';
import NoRecords from '../Shared/NoRecords';
import ContainerCard from '../Shared/container-card';
import ListTable from '../Shared/list-table';

const isSelected = (selectedIds, id) => {
  return selectedIds.includes(id);
};

const RenderTable = ({
  onPageChange,
  pages,
  page,
  results,
  selectedIds,
  onSelectId,
  onSelectAll,
}) => {
  return (
    <ListTable
      onPageChange={onPageChange}
      pages={pages}
      page={page}
      head={
        <TableRow>
          <TableCell>
            <FormattedMessage id="Code" />
          </TableCell>
          <TableCell>
            <FormattedMessage id="Used By" />
          </TableCell>
          <TableCell style={{ width: 80 }} align="center">
            <Checkbox
              checked={selectedIds.length > 0 && selectedIds.length === results.length}
              indeterminate={selectedIds.length > 0 && selectedIds.length < results.length}
              onChange={() => {
                if (selectedIds.length === results.length) {
                  onSelectAll([]);
                } else {
                  onSelectAll(results.map(r => r.id));
                }
              }}
            />
          </TableCell>
        </TableRow>
      }
      body={
        <React.Fragment>
          {results.map((c, i) => {
            return (
              <TableRow key={i}>
                <TableCell>{c.key}</TableCell>
                <TableCell>{c.name}</TableCell>
                <TableCell style={{ width: 80 }} align="center">
                  <Checkbox
                    name={`checkbox_${c.id}`}
                    value={isSelected(selectedIds, c.id)}
                    onChange={e => {
                      e.preventDefault();
                      onSelectId(c.id);
                    }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </React.Fragment>
      }
    />
  );
};

const RenderForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  isSubmitting,
  setFieldValue,
}) => {
  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <Grid container spacing={3} justifyContent="space-between">
        <Grid item xs={6} md={3}>
          <Input
            type="text"
            value={values.key}
            onChange={handleChange}
            name="key"
            label={<FormattedMessage id="Code" />}
            errors={errors}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <Button
            style={{ marginTop: '16px' }}
            variant="contained"
            color="primary"
            type="submit"
            disabled={isSubmitting}
            fullWidth
          >
            <FormattedMessage id="Filter" />
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ({
  onPageChange,
  pages,
  page,
  building,
  company,
  results,
  onDestroy,
  initialValues,
}) => {
  const [selectedIds, setSelectedIds] = React.useState([]);

  const onSelectId = id => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(i => i !== id));
    } else {
      setSelectedIds(selectedIds.concat(id));
    }
  };

  const onSelectAll = ids => setSelectedIds(ids);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              onSubmit={async (values, { setSubmitting, setErrors }) => {
                try {
                  const val = { ...values };
                  if (val.assigned_to_invitation !== '__none__') {
                    val.type = 'permanent';
                  }

                  await onPageChange({ page: 1, ...val });
                  setSelectedIds([]);
                  setSubmitting(false);
                } catch (err) {
                  if (err.response && err.response.data.errors) {
                    setErrors(err.response.data.errors);
                  }

                  setSubmitting(false);
                }
              }}
              render={RenderForm}
            />
          </MuiPickersUtilsProvider>
          <hr />
        </Grid>
        <Grid item md={6}>
          {!!selectedIds.length && (
            <Button
              type="button"
              size="small"
              onClick={async () => {
                await onDestroy(selectedIds);

                setSelectedIds([]);
              }}
              color="secondary"
              variant="contained"
            >
              <FormattedMessage
                id="Delete {length} codes"
                values={{ length: selectedIds.length }}
              />
            </Button>
          )}
        </Grid>
        <Grid item md={6}>
          <div className="text-right">
            <Button
              component={Link}
              variant="contained"
              color="primary"
              to={`/app/buildings/${building.id}${
                company ? `/companies/${company.id}` : ''
              }/keys/create/permanent`}
            >
              <FormattedMessage id="Add permanents' codes" />
            </Button>
            <hr />
          </div>
        </Grid>
      </Grid>
      {!results.length && <NoRecords />}
      {!!results.length && (
        <RenderTable
          {...{
            onPageChange,
            pages,
            page,
            results,
            onSelectId,
            onSelectAll,
            selectedIds,
          }}
        />
      )}
    </>
  );
};
